export const environment = {
  production: false,
  apiUrl: 'https://dev.api.internal.loadboard.odysseylogistics.com/api/v1/',
  redirectUri: window.location.origin,
  authority: 'https://login.microsoftonline.com/',
  graph_endpoint: 'https://graph.microsoft-ppe.com/v1.0',
  azure_clientId: '42e70cd1-670f-4609-ae6b-28bf11240897',
  tenantId: 'a0939492-debd-4ad8-b4f0-475854182417'
};
